import { Col, Flex, Row } from "antd";
import ButtonComponent from "components/button/Button";
import DropdownTriangle from "components/dropdown-triangle";
import InputComponent from "components/formInput/Input";
import Loading from "components/loading/Loading";
import PopupConfirm from "components/popup-confirm";
import useAppDispatch from "hooks/useAppDispatch";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Articles from "./article-items";
import { ARTICLE_LIST_OPTIONS, ARTICLE_LIST_OPTIONS_VALUE } from "./constants";
import "./styles.scss";

const ArticlesList = (props) => {
  const { t } = useTranslation();
  const [idSelecteds, setIdSelecteds] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [isOpenDelete, setIsOpenDelete] = useState(false);

  const history = useHistory();

  const {
    data: {
      listArticles: { data, isLoading, page, total_page },
      updateStatus: { isLoading: isLoadingUpdateStatus },
    },
    actions: {
      actGetListArticles,
      actGetListArticlesReset,
      actUpdateStatusArticles,
    },
  } = useAppDispatch("articles");

  useEffect(() => {
    if (data) {
    }
  }, [data]);

  useEffect(() => {
    fetchArticle();
    return () => {
      actGetListArticlesReset();
    };
  }, []);

  const fetchArticle = (newPage) => {
    const filters = {
      page: newPage || 1,
      limit: 15,
    };

    if (searchInput) {
      filters.key_search = searchInput;
    }
    actGetListArticles(filters);
  };

  const handleChangeStatusSuccess = () => {
    actGetListArticles();
    setIdSelecteds([]);
  };

  const handleAction = (val) => {
    if (idSelecteds?.length === 0) return;
    switch (val?.value) {
      case ARTICLE_LIST_OPTIONS_VALUE.PUBLISH:
        actUpdateStatusArticles(
          {
            news_ids: idSelecteds,
            type: val?.value,
          },
          handleChangeStatusSuccess
        );
        break;
      case ARTICLE_LIST_OPTIONS_VALUE.HIDDEN:
        actUpdateStatusArticles(
          {
            news_ids: idSelecteds,
            type: val?.value,
          },
          handleChangeStatusSuccess
        );
        break;
      default: // delete
        openDeleteModal();

        break;
    }
  };

  const handleDelete = () => {
    if (!data) return;
    actUpdateStatusArticles(
      {
        news_ids: idSelecteds,
        type: ARTICLE_LIST_OPTIONS_VALUE.DELETE,
      },
      () => {
        handleChangeStatusSuccess();
        closeDeleteModal();
      }
    );
  };

  const openDeleteModal = () => {
    setIsOpenDelete(true);
  };

  const closeDeleteModal = () => {
    setIsOpenDelete(false);
  };

  return (
    <div className="article-container main-content">
      <div className="root-right-header">
        <div className="screen-name">{t("admin_role")}</div>
      </div>
      <div className="nav">
        <Flex gap="large" wrap="wrap" align="center">
          <div className="screen-title">{t("articles.title")}</div>

          <DropdownTriangle
            options={ARTICLE_LIST_OPTIONS}
            onClick={handleAction}
          />
        </Flex>
        <Row className="article-header">
          <Col md={7}>
            <InputComponent
              placeholder={t("search")}
              onChange={(e) => {
                setSearchInput(e.target.value);
              }}
              onEnter={() => fetchArticle(1)}
              suffix={
                <img
                  src="/icons/search_img.png"
                  className="ic x2"
                  onClick={() => fetchArticle(1)}
                  alt="search-icon"
                />
              }
            />
          </Col>
          <Col offset={1}>
            <ButtonComponent
              background="#B4E0F3"
              className="btn-create"
              text={t("articles.createArticle")}
              onClick={() => history.push("/admin/articles/create")}
            />
          </Col>
        </Row>
      </div>
      <Articles
        data={data}
        idSelecteds={idSelecteds}
        setIdSelecteds={setIdSelecteds}
      />
      {data.length > 0 &&
        <Row
          style={{
            marginTop: "20px",
            justifyContent: "flex-end",
            padding: "0 20px",
          }}
        >
          <Col style={{ display: "flex" }}>
            {`${page}/${total_page} ${t("pagination")}　`}
            <Flex gap="10px">
              {page > 1 ? (
                <span
                  style={{ cursor: "pointer", transform: "rotate(180deg)" }}
                  onClick={() => {
                    fetchArticle(page - 1);
                  }}
                >
                  ▶
                </span>
              ) : null}
              {page < total_page ? (
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    fetchArticle(page + 1);
                  }}
                >
                  ▶
                </span>
              ) : null}
            </Flex>
          </Col>
        </Row>
      }
      <PopupConfirm
        open={isOpenDelete}
        onCancelText={t("button.cancel")}
        onOkText={t("button.delete")}
        content={t("confirm_delete")}
        onOk={handleDelete}
        onCancel={closeDeleteModal}
        onOkColor="#FF3131"
      />
      {(isLoading || isLoadingUpdateStatus) && <Loading />}
    </div>
  );
};

export default ArticlesList;
